











import {Component, Mixins} from 'vue-property-decorator';
import DefaultComponentMixin from '@/views/DefaultComponentMixin';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';
import NoticeDetailDialog from '@/views/home/NoticeDetailDialog.vue';
import {PopupNoticeInfo, PopupNoticesDialogRequest} from '@/model/CommonModel';

@Component({
  components: {NoticeDetailDialog, CommonPromptDialog, CommonButton},
  mixins: [DefaultComponentMixin]
})
export default class PopupNoticesDialog extends Mixins(DefaultComponentMixin) {
  private values: PopupNoticeInfo[] = [];
  private visible: boolean = false;

  get isVisible() {
    return this.visible;
  }

  get getValues() {
    return this.values;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showPopupNoticesDialog', (params: PopupNoticesDialogRequest) => {
          this.values = params.popupNoticeInfos
              .map(noticeInfo => ({...noticeInfo, visible: true}));
          this.visible = true;
        });

    this.$modal.getEventBus().$on('hidePopupNoticesDialog', () => this.hide());
  }

  public onConfirm(index: number) {
    this.values[index].visible = false;
  }

  public onClose() {
    if (this.values.filter(noticeInfo => noticeInfo.visible).length <= 0) {
      this.hide();
    }
  }

  private hide() {
    this.values = [];
    this.visible = false;
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showPopupNoticesDialog');
    this.$modal.getEventBus().$off('hidePopupNoticesDialog');
  }
}
